const RENDERABLE_BY_KIND = {
    stale_price: true,
    recurring_adhoc: true,
    cross_sell: true,
    discount_leak: true
};
const RECOGNISED_KINDS = new Set(Object.keys(RENDERABLE_BY_KIND));
export const partitionByRecognisedKind = (entries)=>({
        recognised: entries.filter((entry)=>RECOGNISED_KINDS.has(entry.kind)),
        unrecognised: entries.filter((entry)=>!RECOGNISED_KINDS.has(entry.kind))
    });
export const selectVisibleEntries = (entries, prefixSize, isExpanded)=>isExpanded || entries.length <= prefixSize ? {
        visible: [
            ...entries
        ],
        hiddenCount: 0
    } : {
        visible: entries.slice(0, prefixSize),
        hiddenCount: entries.length - prefixSize
    };
